"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdonisClient = exports.TopicStatus = void 0;
var rxjs_1 = require("rxjs");
var url_1 = require("url");
var OpenMessage_1 = require("./messages/OpenMessage");
var EventMessage_1 = require("./messages/EventMessage");
var operators_1 = require("rxjs/operators");
var MessageType_1 = require("./messages/MessageType");
var webSocket_1 = require("rxjs/webSocket");
var OpenAckMessage_1 = require("./messages/OpenAckMessage");
var JoinAckMessage_1 = require("./messages/JoinAckMessage");
var EventCompleteMessage_1 = require("./messages/EventCompleteMessage");
var LeaveAckMessage_1 = require("./messages/LeaveAckMessage");
var JoinErrorMessage_1 = require("./messages/JoinErrorMessage");
var PingMessage_1 = require("./messages/PingMessage");
var PongMessage_1 = require("./messages/PongMessage");
var isomorphic_ws_1 = __importDefault(require("isomorphic-ws"));
var JoinMessage_1 = require("./messages/JoinMessage");
var LeaveMessage_1 = require("./messages/LeaveMessage");
var EventErrorMessage_1 = require("./messages/EventErrorMessage");
var generateTraceId_1 = require("./utils/generateTraceId");
var LeaveErrorMessage_1 = require("./messages/LeaveErrorMessage");
var TopicStatus;
(function (TopicStatus) {
    TopicStatus[TopicStatus["OPEN"] = 0] = "OPEN";
    TopicStatus[TopicStatus["CLOSED"] = 1] = "CLOSED";
})(TopicStatus = exports.TopicStatus || (exports.TopicStatus = {}));
var AdonisClient = (function () {
    function AdonisClient(config, logger, getToken) {
        var _this = this;
        this.openObserver = new rxjs_1.Subject();
        this.closeObserver = new rxjs_1.Subject();
        this.logoutObserver = new rxjs_1.Subject();
        this.lastSubscriptionId = 1;
        this.isSocketConnected = false;
        this.getToken = getToken;
        this.logger = logger;
        this.messages = new rxjs_1.Observable(function (observer) {
            _this.ws = new webSocket_1.WebSocketSubject({
                url: (0, url_1.format)(config.url),
                WebSocketCtor: isomorphic_ws_1.default,
                openObserver: _this.openObserver,
                closeObserver: _this.closeObserver,
                deserializer: function (e) {
                    var message = JSON.parse(e.data);
                    switch (message.t) {
                        case MessageType_1.MessageType.OPEN_ACK:
                            return new OpenAckMessage_1.OpenAckMessage(message.d);
                        case MessageType_1.MessageType.JOIN_ACK:
                            return new JoinAckMessage_1.JoinAckMessage(message.d);
                        case MessageType_1.MessageType.JOIN_ERROR:
                            return new JoinErrorMessage_1.JoinErrorMessage(message.d);
                        case MessageType_1.MessageType.EVENT:
                            return new EventMessage_1.EventMessage(message.d);
                        case MessageType_1.MessageType.EVENT_COMPLETE:
                            return new EventCompleteMessage_1.EventCompleteMessage(message.d);
                        case MessageType_1.MessageType.LEAVE_ACK:
                            return new LeaveAckMessage_1.LeaveAckMessage(message.d);
                        case MessageType_1.MessageType.LEAVE_ERROR:
                            return new LeaveErrorMessage_1.LeaveErrorMessage(message.d);
                        case MessageType_1.MessageType.PONG:
                            return new PongMessage_1.PongMessage();
                        case MessageType_1.MessageType.EVENT_ERROR:
                            return new EventErrorMessage_1.EventErrorMessage(message.d);
                        default:
                            throw new Error('Unknown package ' + e);
                    }
                }
            });
            var subs = _this.ws.subscribe(function (data) {
                observer.next(data);
            }, function (err) {
                observer.error(err);
            }, function () {
                observer.complete();
            });
            return function () {
                subs.unsubscribe();
            };
        }).pipe((0, operators_1.share)());
        this.closeObserver.subscribe(function (event) {
            _this.isSocketConnected = false;
        });
        this.session = this.openObserver.pipe((0, operators_1.tap)(function () {
            _this.ws.next(new OpenMessage_1.OpenMessage({}));
            _this.isSocketConnected = true;
        }), (0, operators_1.mergeMap)(function () {
            return _this.ws.pipe((0, operators_1.filter)(function (message) { return message instanceof OpenAckMessage_1.OpenAckMessage; }));
        }), (0, operators_1.tap)(function () {
            _this.logger.debug('The greeting is finished');
        }), this.heartbeat(config.heartbeatInterval), (0, operators_1.multicast)(function () { return new rxjs_1.ReplaySubject(1); }), (0, operators_1.refCount)());
    }
    AdonisClient.prototype.topic = function (config) {
        var _this = this;
        var metadata = __assign({ traceId: (0, generateTraceId_1.generateTraceId)(), spanId: (0, generateTraceId_1.generateTraceId)() }, config.metadata);
        var status = new rxjs_1.Subject();
        var dataStream = this.session.pipe(function (source) {
            var resultObservable = new rxjs_1.Observable(function (observer) {
                var subscriptionId = _this.lastSubscriptionId++;
                var topicMessages = _this.messages.pipe((0, operators_1.filter)(function (message) {
                    return message.d.i === subscriptionId;
                }));
                topicMessages
                    .pipe((0, operators_1.filter)(function (message) { return message.t === MessageType_1.MessageType.JOIN_ACK; }), (0, operators_1.tap)(function () { return status.next({ status: TopicStatus.OPEN }); }))
                    .subscribe(observer);
                var completeMessage = topicMessages.pipe((0, operators_1.filter)(function (message) {
                    return message.t === MessageType_1.MessageType.LEAVE_ACK || message.t === MessageType_1.MessageType.EVENT_COMPLETE;
                }), (0, operators_1.take)(1), (0, operators_1.tap)(function () { return status.next({ status: TopicStatus.CLOSED }); }));
                var token = (0, operators_1.tap)();
                var logout = (0, operators_1.tap)();
                if (config.isAuthorized && _this.getToken) {
                    token = (0, operators_1.mergeMap)(function () {
                        return _this.getToken().catch(function (err) {
                            throw "Can't get token. Message: ".concat(err);
                        });
                    });
                    logout = (0, operators_1.takeUntil)(_this.logoutObserver);
                }
                var sub = source
                    .pipe((0, operators_1.tap)(function (msg) {
                    _this.logger.debug("Trying to create new subscription: ".concat(config.name, " id=").concat(subscriptionId));
                }), token, (0, operators_1.tap)(function (msg) {
                    _this.ws.next(new JoinMessage_1.JoinMessage({
                        topic: config.name,
                        i: subscriptionId,
                        accessToken: msg.accessToken,
                        metadata: metadata,
                        parameters: config.parameters
                    }));
                }), (0, operators_1.mergeMap)(function () { return topicMessages; }), (0, operators_1.map)(function (message) {
                    if (message instanceof JoinErrorMessage_1.JoinErrorMessage) {
                        _this.logger.debug("Can't join to topic " + config.name + '. Message: ' + message.d.error);
                        status.next({ status: TopicStatus.CLOSED, error: message.d.error });
                        throw message.d.error;
                    }
                    if (message instanceof EventErrorMessage_1.EventErrorMessage) {
                        _this.logger.debug('Subscription ' + config.name + ' ended. Message: ' + message.d.error);
                        status.next({ status: TopicStatus.CLOSED, error: message.d.error });
                        throw message.d.error;
                    }
                    return message;
                }), (0, operators_1.takeUntil)(completeMessage), logout)
                    .subscribe(observer);
                return function () {
                    if (_this.isSocketConnected) {
                        _this.ws.next(new LeaveMessage_1.LeaveMessage({ i: subscriptionId }));
                    }
                    status.next({ status: TopicStatus.CLOSED });
                    sub.unsubscribe();
                    _this.logger.debug('Close subscription id=' + subscriptionId);
                };
            });
            return resultObservable;
        });
        if (config.isRaw) {
            dataStream.status = status;
            return dataStream;
        }
        var result = dataStream.pipe((0, operators_1.filter)(function (message) { return message instanceof EventMessage_1.EventMessage; }), (0, operators_1.map)(function (message) {
            return message.d.d;
        }));
        result.status = status;
        return result;
    };
    AdonisClient.prototype.heartbeat = function (timeout) {
        var _this = this;
        var PONG_TIMEOUT = timeout - 200;
        var ping = (0, rxjs_1.timer)(1000, timeout).pipe((0, operators_1.tap)(function () {
            _this.ws.next(new PingMessage_1.PingMessage());
        }), (0, operators_1.switchMap)(function () {
            return (0, rxjs_1.race)(pong, throwAfterDelay);
        }), (0, operators_1.filter)(function () { return false; }));
        var pong = this.messages.pipe((0, operators_1.filter)(function (message) {
            return message.t === MessageType_1.MessageType.PONG;
        }));
        var throwAfterDelay = (0, rxjs_1.of)(0).pipe((0, operators_1.delay)(PONG_TIMEOUT), (0, operators_1.map)(function () {
            _this.logger.debug('Can`t see pong message at least ' + PONG_TIMEOUT + 'ms');
            throw new Error('Can`t see pong message at least ' + PONG_TIMEOUT + 'ms');
        }));
        if (timeout === 0) {
            return function (source) { return source; };
        }
        else {
            return function (source) { return (0, rxjs_1.merge)(source, ping); };
        }
    };
    AdonisClient.prototype.terminate = function () {
        if (this.ws) {
            this.ws.unsubscribe();
            return this.closeObserver.pipe((0, operators_1.first)()).toPromise();
        }
        return Promise.resolve();
    };
    AdonisClient.prototype.logout = function () {
        this.logoutObserver.next();
    };
    return AdonisClient;
}());
exports.AdonisClient = AdonisClient;
//# sourceMappingURL=AdonisClient.js.map